
export default {
  props: {
    src: {
      type: String,
      default: 'https://res.cloudinary.com/dubaifinancialmarket/image/upload/c_thumb,w_800,g_face/v1674040329/visuals/visual-6_owdwy2',
    },
  },
}
